var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(this.id == 2)?_c('monthlyepf-form',{attrs:{"parentObject":{
            data: this.item,
            id: this.id,
            errMsg: this.errMsg,
            pageTitle: this.pageTitle,
        }},on:{"input":function($event){_vm.formData = $event}}}):_vm._e(),(this.id == 8)?_c('monthlyepfhlb-form',{attrs:{"parentObject":{
            data: this.item,
            id: this.id,
            errMsg: this.errMsg,
            pageTitle: this.pageTitle,
        }},on:{"input":function($event){_vm.formData = $event}}}):_vm._e(),(this.id == 13)?_c('monthlyepfambank-form',{attrs:{"parentObject":{
            data: this.item,
            id: this.id,
            errMsg: this.errMsg,
            pageTitle: this.pageTitle,
        }},on:{"input":function($event){_vm.formData = $event}}}):_vm._e(),(this.id == 20)?_c('monthlyepfcimb-form',{attrs:{"parentObject":{
            data: this.item,
            id: this.id,
            errMsg: this.errMsg,
            pageTitle: this.pageTitle,
        }},on:{"input":function($event){_vm.formData = $event}}}):_vm._e(),(this.id == 33)?_c('monthlyepfaffin-form',{attrs:{"parentObject":{
            data: this.item,
            id: this.id,
            errMsg: this.errMsg,
            pageTitle: this.pageTitle,
        }},on:{"input":function($event){_vm.formData = $event}}}):_vm._e(),(this.id == 27)?_c('monthlyepfpublic-form',{attrs:{"parentObject":{
            data: this.item,
            id: this.id,
            errMsg: this.errMsg,
            pageTitle: this.pageTitle,
        }},on:{"input":function($event){_vm.formData = $event}}}):_vm._e(),(this.id == 38)?_c('monthlyepfhsbc-form',{attrs:{"parentObject":{
            data: this.item,
            id: this.id,
            errMsg: this.errMsg,
            pageTitle: this.pageTitle,
        }},on:{"input":function($event){_vm.formData = $event}}}):_vm._e(),(this.id == 46)?_c('monthlyepfalliance-form',{attrs:{"parentObject":{
            data: this.item,
            id: this.id,
            errMsg: this.errMsg,
            pageTitle: this.pageTitle,
        }},on:{"input":function($event){_vm.formData = $event}}}):_vm._e(),(this.item && this.item.expfmtcode == 'Maybank-EPF')?_c('monthlyepfmaybank-form',{attrs:{"parentObject":{
            data: this.item,
            id: this.id,
            errMsg: this.errMsg,
            pageTitle: this.pageTitle,
        }},on:{"input":function($event){_vm.formData = $event}}}):_vm._e(),(_vm.isErr)?_c('div',[_c('app-error',{attrs:{"parentError":{
                data: this.errMsg,
                isErr: this.isErr
            }},on:{"closeError":function($event){_vm.isErr = $event}}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }